<div class="card-body p-0">
  <div class="mat-elevation-z4">
    <div class="row p-4">
      <div class="col-md-12">
        <h3 class="card-title mb-0">
          <i class="fas fa-pencil-alt pr-2"></i> Matriz de Risco e Controles do processo auditado
        </h3>
      </div>
    </div>
    <mat-toolbar class="table-header">
      <mat-toolbar-row>
        <button type="button" class="btn btn-success btn-sm mr-1" [disabled]="visualizar" *ngIf="!visualizar"
          (click)="incluir('Incluir',false)">
          <i class="far fa-file"></i> Novo
        </button>
        <button type="button" class="btn btn-primary btn-sm mr-1" [disabled]="!selectedModel || visualizar"
          *ngIf="!visualizar" (click)="incluir('Editar', false, selectedModel)">
          <i class="fas fa-pen"></i> Editar
        </button>
        <button type="button" class="btn btn-danger btn-sm mr-1" [disabled]="!selectedModel || visualizar"
          *ngIf="!visualizar" (click)="excluir(selectedModel?.id)">
          <i class="fa fa-trash"></i> Excluir
        </button>
        <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel"
          (click)="incluir('Visualizar', true, selectedModel)">
          <i class="far fas fa-eye"></i> Visualizar
        </button>
        <button type="button" class="btn btn-info btn-sm mr-1" *ngIf="podeImprimir" [disabled]="!selectedModel"
          (click)="imprimir(selectedModel)">
          <i class="far fas fa-print"></i> Imprimir
        </button>

        <button type="button" class="btn btn-warning btn-sm mr-1" (click)="incluir('Importar', false, null, true)"
          *ngIf="!visualizar">
          <i class="far fas fa-file-import"></i> Importar
        </button>

        <button type="button" class="btn btn-info btn-sm mr-1" [disabled]="!selectedModel"
          (click)="exportar(selectedModel)">
          <i class="far fas fa-file-export"></i> Exportar
        </button>

        <span class="fill-remaining-space"></span>
        <div class="input-group input-group-sm" style="width:
          150px;">
          <input type="text" name="table_search" class="form-control
            float-right" placeholder="Pesquisar" [(ngModel)]="searchNome" (keyup.enter)="buscar()" />

          <div class="input-group-append">
            <button type="button" class="btn btn-info" (click)="buscar()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>

      </mat-toolbar-row>
    </mat-toolbar>
    <table [hidden]="semDados" mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-100 " matSort
      matSortDisableClear>
      <ng-container matColumnDef="selecao">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox (click)="$event.stopPropagation()" color="primary" (change)="selecionar(element)"
            [checked]="selectedModel?.id === element.id">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="siglaUG">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>UG - Sigla</th>
        <td mat-cell *matCellDef="let element">{{ element?.siglaUG }}</td>
      </ng-container>

      <ng-container matColumnDef="nomeProcesso">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Processo de trabalho auditado</th>
        <td mat-cell *matCellDef="let element" style="word-wrap: break-word;overflow-wrap: anywhere;">{{ element?.nomeProcesso }}</td>
      </ng-container>

      <ng-container matColumnDef="descricaoCriterioRisco">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Critério de Avaliação de Risco</th>
        <td mat-cell *matCellDef="let element" style="word-wrap: break-word;overflow-wrap: anywhere;">{{ element?.descricaoCriterioRisco }}</td>
      </ng-container> 

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selecionar(row)" class="clickable"
        [ngClass]="{'bg-light': selectedModel?.id === row.id}"></tr>
    </table>
    <h5 [hidden]="!semDados" class="table-no-data">
      Nenhum registro encontrado.
    </h5>
    <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons (page)="selectedModel= null">
    </mat-paginator>
    <app-imprimir-matriz-risco #printComp [dados]="selectedModel" style="display: none;"></app-imprimir-matriz-risco>

  </div>
</div>